export default "__VITE_ASSET__3f2e91a3__"